<template>
  <div class="inner _pb-md LogRecord">
    <div class="LogRecord__total_area">
      <div id="hour" class="LogRecord__total_box">
        <div class="LogRecord__total_head">
          マインドフルネス合計時間
        </div>
        <div
          id="box1"
          class="LogRecord__total_label LogRecord__total_label_img LogRecord__total_label_img--hours ft_en"
        >
          <span id="counterHours" class="LogRecord__total_tx_num count count-fast">{{ totalHours }}</span><span
            class="LogRecord__total_tx"
          >hours</span>
        </div>
      </div>
      <div id="session" class="LogRecord__total_box">
        <div class="LogRecord__total_head">
          参加クラス数
        </div>
        <div class="LogRecord__total_label LogRecord__total_label_img LogRecord__total_label_img--sessions ft_en">
          <span id="counterSessions" class="LogRecord__total_tx_num">{{ totalSessions }}</span><span
            class="LogRecord__total_tx"
          >sessions</span>
        </div>
      </div>
    </div>
    <div class="LogRecord__area">
      <div class="LogRecord__box LogRecord__calendar">
        <calendar
          :key="reloadKey"
          :select-month="selectMonth"
          :dates-have-log="datesHaveLog"
          @allLogOfUser="allLogOfUser"
          @selectDate="selectDate"
          @nextMonth="nextMonth"
          @prevMonth="prevMonth"
        />
      </div>

      <div class="LogRecord__box LogRecord__record">
        <div class="LogRecord__record_top">
          <!-- eslint-disable vue/no-v-html -->
          <div class="LogRecord__record_date ft_en" v-html="showSelectedDate()" />
          <div
            v-if="selectedLogStatus === 0 && detailLog !== null"
            class="LogRecord__edit_btn"
            @click="isOpenUpdateStep = true"
          >
            編集
          </div>
          <div class="LogRecord__back_btn_arrow LogRecord__close" />
        </div>
        <div class="LogRecord__record_area">
          <div class="LogRecord__back_btn _hover-cl LogRecord__close">
            戻る
          </div>
          <div
            v-if="selectedLogStatus === -1"
            class="Btn Btn--line LogRecord__record_con LogRecord__record_btn "
            @click="isOpenWriteStep1 = true"
          >
            ログをとる
          </div>
          <div v-if="selectedLogStatus === 0 && detailLog !== null" class="LogRecord__record_inner">
            <div class="LogRecord__record_bar_area">
              <div :class="`LogRecord__record_bar_box LogRecord__record_bar_box--${handleSlider(detailLog['heart_beat_rate'])}`">
                <div class="LogRecord__record_bar_head _ft-cl04">
                  心の状態
                </div>
                <div class="LogRecord__record_bar">
                  <div class="LogRecord__record_bar_inner" />
                </div>
              </div>
              <div :class="`LogRecord__record_bar_box LogRecord__record_bar_box--${handleSlider(detailLog['health_state'])}`">
                <div class="LogRecord__record_bar_head _ft-cl05">
                  体の状態
                </div>
                <div class="LogRecord__record_bar LogRecord__record_bar--orange">
                  <div class="LogRecord__record_bar_inner" />
                </div>
              </div>
            </div>
            <div class="LogRecord__record_time">
              <div class="LogRecord__record_time_box">
                <div class="LogRecord__record_time_box_inner">
                  <div class="LogRecord__record_time_head">
                    <span
                      class="LogRecord__record_time_head_tx"
                    >MELONでの瞑想</span>
                  </div>
                  <div class="LogRecord__record_time_tx">
                    <span class="LogRecord__record_time_tx_num ft_en">
                      {{ detailLog['meditation_melontv'] }}
                    </span>
                    <span>分</span>
                  </div>
                </div>
                <div class="LogRecord__record_notes">
                  ※クラス受講・MELON TVの視聴時間
                </div>
              </div>
              <div class="LogRecord__record_time_box">
                <div class="LogRecord__record_time_box_inner">
                  <div class="LogRecord__record_time_head">
                    <span class="LogRecord__record_time_head_tx">個人の瞑想</span>
                  </div>
                  <div class="LogRecord__record_time_tx">
                    <span class="LogRecord__record_time_tx_num ft_en">
                      {{ detailLog['meditation_time'] }}
                    </span>
                    <span>分</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="LogRecord__record_memo">
              <div class="LogRecord__record_memo_head">
                ジャーナリング
              </div>
              <div class="LogRecord__record_memo_area">
                <p>
                  {{ detailLog['diary'] }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="selectedLogStatus === 1" class="LogRecord__record_con LogRecord__record_error ">
            未来の日付のログはとれません
          </div>
        </div>
      </div>
      <log-write-modal
        :is-open="isOpenWriteStep1"
        :create-time="createdTime"
        @close="closeModalWrite"
      />
      <log-update-modal
        :is-open="isOpenUpdateStep"
        :is-detail="detailLog"
        :list-zooms="listZoom"
        :list-melons="listMelonLog"
        :full-time="full_time"
        @close="closeModalUpdate"
      />
    </div>
  </div>
</template>
<script>
import Calendar from '@/views/components/Log/Calendar'
import moment from 'moment'
import LogWriteModal from '@/views/pages/log/components/LogWriteModal'
import LogService from '@/services/logService'
import LogUpdateModal from '@/views/pages/log/components/LogUpdateModal'
// import CheckMobile from '@/helpers/checkMobie'
import melonLogService from '@/services/melonLogService'
import zoomLogService from '@/services/zoomLogService'
const releaseTime = '2021/11/20'

export default {
  name: 'LogCalendar',
  components: { Calendar, LogWriteModal, LogUpdateModal },
  data() {
    return {
      selectMonth: moment(),
      datesHaveLog: ['2021-08-25'],
      selectedDate: '',
      selectedLogStatus: 0,
      isOpenWriteStep1: false,
      isOpenUpdateStep: false,
      totalHours: 0,
      totalSessions: 0,
      allLogs: null,
      detailLog: null,
      createdTime: '',
      reloadKey: 0,
      listZoom: [],
      listMelonLog: [],
      full_time: 0,
      width: 0,
      height: 0,
      isMobile: false,
      showHour: false,
      showSession: false,
      userData: {}
    }
  },
  watch: {
    userData: function(data) {
      this.countHours(data)
      this.countSessions(data)
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.getUser()
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      if (this.width <= 1024) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    async getUser() {
      this.$store.dispatch('loading/updateLoading', true)
      const user = await LogService.getUser()
      this.userData = user.data
      if (!this.isMobile) {
        this.countHours(this.userData)
        this.countSessions(this.userData)
      }
      this.$store.dispatch('loading/updateLoading', false)
    },
    handleScroll() {
      const position = document.querySelector('#hour').getBoundingClientRect()
      if (this.isMobile) {
        if (this.height < 800) {
          if (position.top < 500 && !this.showHour) {
            this.countHours(this.userData)
            this.showHour = true
          }
          if (position.top < 390 && !this.showSession) {
            this.countSessions(this.userData)
            this.showSession = true
          }
        } else {
          if (position.top < 635 && !this.showHour) {
            this.countHours(this.userData)
            this.showHour = true
          }
          if (position.top < 525 && !this.showSession) {
            this.countSessions(this.userData)
            this.showSession = true
          }
        }
      }
    },
    allLogOfUser(allLogs) {
      this.allLogs = allLogs
    },
    counterAdmin(qSelector, start = 0, end, duration = 1000) {
      const target = document.querySelector(qSelector)
      let startTimestamp = null
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp
        const progress = Math.min((timestamp - startTimestamp) / duration, 1)
        target.innerText = Math.floor(progress * (end - start) + start)
        if (progress < 1) {
          window.requestAnimationFrame(step)
        }
      }
      window.requestAnimationFrame(step)
    },
    dateHasLog(date) {
      return this.datesHaveLog.indexOf(date) !== -1
    },
    showSelectedDate() {
      if (!this.selectedDate) return ''
      return `<span>${this.selectedDate.format('YYYY.M.DD')}</span><span>&#040;${this.selectedDate.format('ddd')}&#041;</span>`
    },
    showDateLog(date) {
      this.selectedLogStatus = 0
    },
    selectDate(date) {
      if (Date.parse(date) > Date.parse(releaseTime)) {
        this.selectedDate = moment(date)
        this.createdTime = moment(date).format('YYYY-MM-DD')
        const dateDiffToday = this.selectedDate.diff(moment(), 'day', true)
        this.handleDate(this.selectedDate._i, dateDiffToday)
      }
    },
    handleDate(date, dateDiff) {
      let keyData = 0
      if (this.allLogs !== null) {
        this.allLogs.forEach(element => {
          const logDay = moment(element['created_at']).format('YYYY-MM-DD')
          if (date === logDay) {
            this.full_time = 0
            zoomLogService.getTime(logDay).then(result => {
              this.listZoom = result.data
              this.full_time += result.time
            })
            melonLogService.getTime(logDay).then(result => {
              this.listMelonLog = result.data
              this.full_time += result.time
            })
            this.detailLog = element
            keyData++
          }
        })
      }
      this.showLogRecord(dateDiff, keyData)
    },
    showLogRecord(dateDiff, keyData) {
      if (this.detailLog !== null && keyData >= 1) {
        this.selectedLogStatus = 0
        if (this.isMobile) {
          const log_id = this.detailLog.id
          this.$router.push('/log/update-record/' + log_id)
        }
      } else if (dateDiff > 0) {
        this.selectedLogStatus = 1
      } else {
        this.selectedLogStatus = -1
        if (this.isMobile) {
          this.isOpenWriteStep1 = true
        }
      }
    },
    handleSlider(slider) {
      if (slider < 10) {
        return '0' + slider
      }
      return slider
    },
    nextMonth() {
      this.selectMonth = moment(this.selectMonth).add(1, 'month')
    },
    prevMonth() {
      const month = moment(this.selectMonth).subtract(1, 'month')
      const format_month = moment(month).format('YYYY/MM/01 00:00:00')
      const format_release_time = moment(releaseTime, 'YYYY/MM/DD').format('YYYY/MM/01 HH:mm:ss')
      if (Date.parse(format_month) >= Date.parse(format_release_time)) {
        this.selectMonth = month
      }
    },
    countSessions(user) {
      const sessions = user.watch_melontv_class
      if (sessions > 0) {
        this.totalSessions = sessions
      }
      this.counterAdmin('#counterSessions', 0, this.totalSessions, 1500)
    },
    countHours(user) {
      const minutes = user.total_meditation_time
      if (minutes > 0) {
        this.totalHours = minutes / 60
        this.counterAdmin('#counterHours', 0, this.totalHours, 1500)
      } else {
        this.counterAdmin('#counterHours', 0, this.totalHours, 1500)
      }
    },
    closeModalWrite(type) {
      this.isOpenWriteStep1 = false
      this.$emit('reload', type)
    },
    closeModalUpdate(type) {
      this.isOpenUpdateStep = false
      this.$emit('reload', type)
    }
  }

}
</script>
